export const isInternalUrl = () => {
  const urls = ['saleshandy.com', 'lifeisgoodforlearner.com'];
  const currentBaseUrl = window.location.hostname;

  return urls.some((url) => currentBaseUrl.includes(url));
};
